(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

(function () {

  function initProductRecommendationSlider() {

    const sliders = document.querySelectorAll(
      '.ps-product-recommendations .ps-recommendations-list'
    );

    sliders.forEach(function (slider) {

      if (slider.dataset.autoplayReady === 'true') {
        return;
      }

      const cards = slider.querySelectorAll(':scope > li');

      if (cards.length < 2) {
        return;
      }

      slider.dataset.autoplayReady = 'true';

      let currentSlide = 0;
      let autoplayInterval = null;

      function isMobile() {
        return window.innerWidth <= 749;
      }

      function getSlideWidth() {

        const card = cards[0];

        if (!card) {
          return 0;
        }

        const sliderStyle = window.getComputedStyle(slider);

        const gap = parseFloat(sliderStyle.columnGap || sliderStyle.gap) || 0;

        return card.getBoundingClientRect().width + gap;
      }

      function moveToNextSlide() {

        if (!isMobile()) {
          return;
        }

        const slideWidth = getSlideWidth();

        if (!slideWidth) {
          return;
        }

        currentSlide++;

        /*
         * Last product ke baad first product par wapas
         */

        if (currentSlide >= cards.length) {

          currentSlide = 0;

        }

        slider.scrollTo({
          left: currentSlide * slideWidth,
          behavior: 'smooth'
        });

      }

      function startAutoplay() {

        if (!isMobile()) {
          return;
        }

        if (autoplayInterval) {
          clearInterval(autoplayInterval);
        }

        autoplayInterval = setInterval(function () {

          moveToNextSlide();

        }, 3000);

      }

      function stopAutoplay() {

        if (autoplayInterval) {

          clearInterval(autoplayInterval);

          autoplayInterval = null;

        }

      }


      /*
       * Start autoplay
       */

      startAutoplay();


      /*
       * Pause while user is touching
       */

      slider.addEventListener('touchstart', function () {

        stopAutoplay();

      }, { passive: true });


      /*
       * Resume after swipe
       */

      slider.addEventListener('touchend', function () {

        setTimeout(function () {

          startAutoplay();

        }, 800);

      }, { passive: true });


      /*
       * Mouse interaction
       */

      slider.addEventListener('mouseenter', function () {

        if (!isMobile()) {
          return;
        }

        stopAutoplay();

      });


      slider.addEventListener('mouseleave', function () {

        if (!isMobile()) {
          return;
        }

        startAutoplay();

      });


      /*
       * Window resize
       */

      window.addEventListener('resize', function () {

        if (isMobile()) {

          startAutoplay();

        } else {

          stopAutoplay();

        }

      });

    });

  }


  /*
   * Initial check
   */

  document.addEventListener(
    'DOMContentLoaded',
    initProductRecommendationSlider
  );


  /*
   * Shopify recommendations can load dynamically.
   */

  const observer = new MutationObserver(function () {

    initProductRecommendationSlider();

  });


  observer.observe(document.body, {

    childList: true,

    subtree: true

  });


  /*
   * Extra check after Shopify has loaded
   */

  setTimeout(function () {

    initProductRecommendationSlider();

  }, 1000);


  setTimeout(function () {

    initProductRecommendationSlider();

  }, 2500);


})();


  } catch(e) { console.error(e); }
})();
})();
